/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Pit2_DInputs */

const en_to_yaml_pit2_d = /** @type {(inputs: To_Yaml_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every JSON document is valid YAML, but not every YAML document is valid JSON. Anchors, multiple documents in one file, non string keys, and comments have no JSON equivalent. This tool converts one direction only, and a YAML file that uses those features cannot be represented as JSON without restructuring.`)
};

const ko_to_yaml_pit2_d = /** @type {(inputs: To_Yaml_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 JSON 문서는 유효한 YAML이지만, 모든 YAML 문서가 유효한 JSON인 것은 아닙니다. 앵커, 한 파일 안의 여러 문서, 문자열이 아닌 키, 주석은 JSON에 대응물이 없습니다. 이 도구는 한 방향만 변환하며, 그런 기능을 쓰는 YAML 파일은 구조를 바꾸지 않고는 JSON으로 표현할 수 없습니다.`)
};

const ja_to_yaml_pit2_d = /** @type {(inputs: To_Yaml_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての JSON 文書は妥当な YAML ですが、すべての YAML 文書が妥当な JSON とは限りません。アンカー、1 ファイル内の複数文書、文字列でないキー、コメントには JSON の対応物がありません。このツールは一方向のみ変換し、そうした機能を使う YAML ファイルは構造を変えずに JSON で表現できません。`)
};

/**
* | output |
* | --- |
* | "Every JSON document is valid YAML, but not every YAML document is valid JSON. Anchors, multiple documents in one file, non string keys, and comments have no ..." |
*
* @param {To_Yaml_Pit2_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_pit2_d = /** @type {((inputs?: To_Yaml_Pit2_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Pit2_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_pit2_d(inputs)
	if (locale === "ko") return ko_to_yaml_pit2_d(inputs)
	return ja_to_yaml_pit2_d(inputs)
});